import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useQuery } from 'react-admin';
import {
  getSitePlanningUrl,
  pickMainSite,
} from '../../../../helpers/cleanyApp';

const getDestination = (mainSite) => {
  if (!mainSite) {
    return 'Dans CleanyApp, choix du site';
  }
  if (!mainSite.name) {
    return 'Dans CleanyApp, planning du site principal';
  }
  return `Dans CleanyApp, planning de ${mainSite.name}`;
};

// La déclaration d'une préaffectation se fait dans CleanyApp (plan 070b). Le
// lien ouvre, dans un nouvel onglet, le planning du site principal du cleaner :
// celui de l'affectation permanente active qui compte le plus d'heures par
// semaine. Sans site connu (aucune affectation, chargement en cours, erreur),
// il ouvre la heatmap, où l'on choisit le site ; fermer le drawer y ramène
// aussi.
const PreaffectationButton = ({ className, record }) => {
  const cleanerId = record && record.id;
  const { data: affectations } = useQuery(
    {
      type: 'getManyReference',
      resource: 'affectation',
      payload: {
        target: 'cleaner_id',
        id: cleanerId,
        sort: { field: 'duration_per_week,id', order: 'DESC,DESC' },
        pagination: { page: 1, perPage: 10 },
        filter: { type: 'Permanent', active: true },
      },
    },
    { enabled: !!cleanerId },
  );
  const mainSite = pickMainSite(affectations);

  return (
    <MenuItem
      className={className}
      component="a"
      href={getSitePlanningUrl(mainSite && mainSite.id)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <ListItemText
        primary="📣 Déclarer une préaffectation ↗"
        secondary={getDestination(mainSite)}
      />
    </MenuItem>
  );
};

PreaffectationButton.propTypes = {
  className: PropTypes.string,
  record: PropTypes.object,
};

PreaffectationButton.defaultProps = {
  className: undefined,
  record: undefined,
};

export default PreaffectationButton;
